function roundDiscountPercent(value, mode) {
  if (mode === 'round') return Math.round(value);
  if (mode === 'ceil') return Math.ceil(value);
  return Math.floor(value);
}

class AccessoryProduct extends HTMLElement {
  options = [];
  currentId;
  variants;
  isSelected = false;

  constructor() {
    super();
    this.init();
  }

  init() {
    // 初始化数据
    this.initData();
    // 初始化选择状态监听
    this.initSelectionHandler();
    // 初始化变体选择监听
    this.initVariantHandler();
    // 初始化详情按钮
    this.initDetailButton();
  }

  initData() {
    try {
      this.options = this.dataset.options
        ? JSON.parse(this.dataset.options)
        : [];
      this.variants = this.dataset.variants
        ? JSON.parse(this.dataset.variants)
        : [];
      this.currentId = this.dataset.currentVariant || null;
    } catch (error) {
      console.error('初始化错误', error);
    }
  }

  initSelectionHandler() {
    // 获取复选框元素
    this.checkbox = this.querySelector(
      'input[type="checkbox"][data-position="isSelected"]'
    );
    if (!this.checkbox) return;

    // 监听复选框变化
    this.checkbox.addEventListener('change', () => {
      this.isSelected = this.checkbox.checked;
      this.updatePrice();
    });
  }

  initVariantHandler() {
    // 监听颜色选择
    const colorOptions = this.querySelectorAll(
      '.product-colot-option input[type="radio"]'
    );
    colorOptions.forEach((option) => {
      option.addEventListener('change', (event) => {
        this.handleVariantChange(event);
      });
    });

    // 监听其他变体选择
    const variantSelects = this.querySelectorAll('select[data-position]');
    variantSelects.forEach((select) => {
      select.addEventListener('change', (event) => {
        this.handleVariantChange(event);
      });
    });
  }

  initDetailButton() {
    const detailButton = this.querySelector('.show-detail');
    if (detailButton) {
      const dialog = this.querySelector('dialog');
      detailButton.addEventListener('click', (event) => {
        event.stopPropagation();
        if (dialog) {
          dialog.showModal();
          window.zzLockBodyScroll && window.zzLockBodyScroll();
        }
      });
      // 监听关闭事件
      dialog.addEventListener('close', function () {
        console.log('Dialog 已关闭');
        window.zzUnlockBodyScroll && window.zzUnlockBodyScroll();
      });
    }
  }

  handleVariantChange(event) {
    const position = parseInt(event.target.dataset.position) - 1;
    if (isNaN(position)) return;

    this.options[position] = event.target.value;
    const matchedVariant = this.variants.find(
      (variant) =>
        JSON.stringify(variant.options) === JSON.stringify(this.options)
    );

    if (matchedVariant) {
      this.updateVariant(matchedVariant);
    }
  }

  updateVariant(variant) {
    this.currentId = variant.id;
    this.updateImage(variant);
    this.updatePrice();
    this.updateDialogInfo(variant);
  }

  updateImage(variant) {
    const image = this.querySelector('.image');
    if (image && variant.featured_image) {
      image.src = `${variant.featured_image.src}&width=200`;
      image.srcset = `${variant.featured_image.src}&width=200`;
    }
  }

  updatePrice() {
    const priceTag = Array.from(this.querySelectorAll('.price'));
    priceTag.forEach((tag, index) => {
      if (tag.dataset.productId == this.currentId) {
        tag.classList.remove('tw-hidden');
        tag.classList.add('current-price');
      } else {
        tag.classList.add('tw-hidden');
        tag.classList.remove('current-price');
      }
    });

    // 更新购买栏价格
    const bar = document.querySelector('buy-bottom-bar');
    if (bar) {
      bar.updatePrice();
    }
  }

  updateDialogInfo(variant) {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;

    console.log('variant', variant);

    const dialogPrice = dialog.querySelector('[data-product-variant-price]');

    if (dialogPrice)
      dialogPrice.innerHTML = this.moneyWithoutTrailingZeros(
        variant.price,
        this.dataset.cartCurrency
      );

    if (variant.price === variant.compare_at_price) {
      // hide compare at price & discount percentage
      const dialogCompareAtPrice = dialog.querySelector(
        '[data-product-variant-compare-at-price]'
      );
      const dialogDiscountPercentage =
        dialog.querySelector('[data-product-variant-discount-percentage]') ||
        dialog.querySelector('.price-discouter');
      if (dialogCompareAtPrice) dialogCompareAtPrice.classList.add('tw-hidden');
      if (dialogDiscountPercentage)
        dialogDiscountPercentage.classList.add('tw-hidden');
    } else {
      // show compare at price & discount percentage
      const dialogCompareAtPrice = dialog.querySelector(
        '[data-product-variant-compare-at-price]'
      );
      const dialogDiscountPercentage =
        dialog.querySelector('[data-product-variant-discount-percentage]') ||
        dialog.querySelector('.price-discouter');
      if (dialogCompareAtPrice) {
        dialogCompareAtPrice.classList.remove('tw-hidden');
        dialogCompareAtPrice.innerHTML = this.moneyWithoutTrailingZeros(
          variant.compare_at_price,
          this.dataset.cartCurrency
        );
      }
      if (dialogDiscountPercentage) {
        dialogDiscountPercentage.classList.remove('tw-hidden');
        const discountPercentage =
          ((variant.compare_at_price - variant.price) /
            variant.compare_at_price) *
          100;
        const rounded = roundDiscountPercent(
          discountPercentage,
          this.dataset.percentRound
        );
        dialogDiscountPercentage.innerHTML = '- ' + rounded + '%';
      }
    }
  }

  getNumber() {
    const quantityInput = this.querySelector('.product-counter input');
    return quantityInput ? quantityInput.value : '1';
  }

  moneyWithoutTrailingZeros(cents, currency) {
    const money = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(cents / 100);
    return money.replace(/\.00$/, '');
  }
}
class AccessoryDialog extends HTMLElement {
  isOpen = false;
  swiper = null; // swiper实例

  constructor() {
    super();
    this.init();
  }

  init() {
    const dialog = this.querySelector('dialog');
    if (dialog) {
      const observer = new MutationObserver(() => {
        if (dialog.open) {
          // 初始化swiper
          if (!this.swiper) {
            this.initSwiper();
          }
        } else {
          // 销毁swiper
          if (this.swiper) {
            this.destroySwiper();
          }
        }
      });

      // 监听dialog open
      observer.observe(dialog, { attributes: true });

      // 添加关闭事件监听
      dialog.addEventListener('close', () => {
        // 确保在关闭时销毁swiper
        if (this.swiper) {
          this.destroySwiper();
        }
      });
    }
  }

  // 初始化
  initSwiper() {
    const swiperContainer = this.querySelector('.swiper');
    if (swiperContainer) {
      this.swiper = new Swiper(swiperContainer, {
        loop: true,
        pagination: {
          el: this.querySelector('.detail-swiper-pagination'),
          clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 0,
      });
    }
  }

  // 销毁
  destroySwiper() {
    if (this.swiper) {
      // 完全销毁swiper，包括所有事件监听器和DOM元素
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('accessory-product')) {
  customElements.define('accessory-product', AccessoryProduct);
}
if (!customElements.get('accessory-dialog')) {
  customElements.define('accessory-dialog', AccessoryDialog);
}
